import { Star as StarIcon } from '@mui/icons-material';
import { chipClasses, styled } from '@mui/material';

import { variants } from '../../../components/DateWidget';
import { generateClasses } from '../../../utils/helper';
import ZoomUsIcon from '../../../icons/ZoomUsIcon';
import Tag from '../../../components/Tag';

enum ClassGridAreas {
  DATE_WIDGET = 'dateWidget',
  WIDGET_TYPE = 'widgetType',
  ACTIONS = 'actions',
  TIMINGS = 'timings',
  TITLE = 'title',
}

export const classCardClasses = generateClasses('ClassWidget', [
  'root',
  'classGrid',
  ...Object.values(ClassGridAreas),
  ...variants,
  'zoomUsIcon',
  'activityName',
  'inSessionTag',
  'completedTag',
  'activities',
]);

export const Root = styled('div')(({ theme }) => ({
  display: 'block',
  width: '100%',
  backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%)`,
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: 6,
  overflow: 'hidden',
  textAlign: 'left',

  [`&.${classCardClasses.past}`]: {
    backgroundImage: 'none',
    backgroundColor: theme.palette.grey[50],
    [`& .${classCardClasses.activityName}`]: {
      color: theme.palette.grey[600],
    },
    [`& .${classCardClasses.timings}`]: {
      color: theme.palette.grey[600],
    },
    [`& .${classCardClasses.title}`]: {
      color: theme.palette.grey[500],
    },
  },

  [`&.${classCardClasses.near}`]: {
    [`& .${classCardClasses.timings}`]: {
      color: theme.palette.error[400],
    },
  },
}));

export const ClassGrid = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateAreas: `
    "${ClassGridAreas.DATE_WIDGET} ${ClassGridAreas.WIDGET_TYPE}  ${ClassGridAreas.ACTIONS}"
    "${ClassGridAreas.DATE_WIDGET} ${ClassGridAreas.TIMINGS}      ${ClassGridAreas.TIMINGS}"
    "${ClassGridAreas.DATE_WIDGET} ${ClassGridAreas.TITLE}        ${ClassGridAreas.TITLE}"
  `,
  gridTemplateColumns: 'auto 1fr auto',
  gridTemplateRows: 'auto auto auto',
  gap: theme.spacing(0.75, 2.25),
  padding: theme.spacing(3.75),
  borderBottom: `1px solid ${theme.palette.grey[200]}`,
  [`& .${classCardClasses.dateWidget}`]: {
    gridArea: ClassGridAreas.DATE_WIDGET,
  },
  [`& .${classCardClasses.widgetType}`]: {
    gridArea: ClassGridAreas.WIDGET_TYPE,
  },
  [`& .${classCardClasses.actions}`]: {
    gridArea: ClassGridAreas.ACTIONS,
  },
  [`& .${classCardClasses.timings}`]: {
    gridArea: ClassGridAreas.TIMINGS,
  },
  [`& .${classCardClasses.title}`]: {
    gridArea: ClassGridAreas.TITLE,
  },
}));

export const StyledZoomUsIcon = styled(ZoomUsIcon)(({ theme }) => ({
  height: theme.spacing(3.75),
  width: theme.spacing(3.75),
}));

export const Activities = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  justifyItems: 'center',
  alignContent: 'center',
  height: theme.spacing(12),
}));

export const StyledStarIcon = styled(StarIcon)(({ theme }) => ({
  color: theme.palette.error[500],
}));

export const StyledTag = styled(Tag)(({ theme }) => ({
  padding: theme.spacing(0.25, 1.5),
  [`& .${chipClasses.label}`]: {
    fontSize: theme.typography.pxToRem(10),
  },
}));
